import { sliderAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const baseStyle = definePartsStyle({
    container: {
        _disabled: {
            opacity: 1,
        },
    },
    track: {
        height: ".5rem",
        backgroundColor: "semantic.background.disabled",
    },
    mark: {
        color: "semantic.text.primary",
        top: "120%",
        textAlign: "center",
        transform: "translateX(-50%)",
        _disabled: {
            color: "semantic.border.secondary",
        },
    },
    thumb: {
        height: "2rem",
        width: "2rem",
        boxShadow: "none",
        _hover: {
            boxShadow: "large",
        },
        _focusVisible: {
            backgroundColor: "semantic.interactive.primary",
            outline: "3px solid",
            outlineColor: "semantic.outline.focus",
            boxShadow: "large",
            _hover: {
                boxShadow: "large",
            },
            _active: {
                backgroundColor: "semantic.cta.secondaryPressed",
                outline: "none",
                transform: "translateY(-50%) scale(1)",
            },
        },
        _active: {
            boxShadow: "medium",
            _hover: {
                boxShadow: "medium"
            },
            backgroundColor: "semantic.cta.secondaryPressed",
            outline: "none",
            transform: "translateY(-50%) scale(1)",
        },
        _disabled: {
            backgroundColor: "semantic.border.secondary",
            color: "semantic.icon.inverse",
        },
    },
});
const variants = {
    default: definePartsStyle({
        thumb: {
            backgroundColor: "semantic.interactive.primary",
        },
    }),
    withIcon: definePartsStyle({
        thumb: {
            backgroundColor: "semantic.interactive.primary",
            color: "semantic.icon.inverse",
            _hover: {
                color: "semantic.cta.secondaryHover",
            },
            _focusVisible: {
                color: "semantic.cta.secondaryHover",
            },
            _active: {
                color: "semantic.icon.inverse",
                _hover: {
                    color: "semantic.icon.inverse",
                },
            },
        },
    }),
};
const sliderTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: {
        variant: "default",
    },
});
export default sliderTheme;
//# sourceMappingURL=Slider.default.js.map